export default __webpack_public_path__ + "static/media/spotify-brands.745d72d9.svg";